import { AxiosResponse } from 'axios'
import { ICryptoCurrency, ICurrency, IGetRateParams, IRate } from './types'
import { apiClient } from '@/entities/httpClient'

const urls = {
  cryptoCurrencies: '/currencies/crypto',
  fiatCurrencies: '/currencies/fiat',
  rate: (nickname: string) => `/streamer/${nickname}/calculate-rate`,
}

export const currenciesApi = {
  async getCryptoCurrencies(): Promise<AxiosResponse<ICryptoCurrency[]>> {
    return apiClient.request({
      url: urls.cryptoCurrencies,
      method: 'GET',
    })
  },
  async getFiatCurrencies(): Promise<AxiosResponse<ICurrency[]>> {
    return apiClient.request({
      url: urls.fiatCurrencies,
      method: 'GET',
    })
  },
}

export const rateApi = {
  async getRate(params: IGetRateParams, nickname: string): Promise<AxiosResponse<IRate>> {
    return apiClient.request({
      url: urls.rate(nickname),
      method: 'POST',
      data: params,
    })
  },
}
